import React from 'react';

const SearchIcon = (): JSX.Element => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            /* eslint-disable-next-line max-len */
            d="M12.7185 5.54774C12.7316 4.58985 12.3647 3.66726 11.6984 2.98295C11.0321 2.29863 10.121 1.90863 9.16568 1.89874C8.21031 1.88886 7.28887 2.2599 6.60407 2.93024C5.91927 3.60058 5.5272 4.51531 5.51411 5.4732C5.50101 6.43109 5.86798 7.35367 6.53427 8.03799C7.20056 8.72231 8.1116 9.11231 9.06697 9.12219C10.0223 9.13207 10.9438 8.76103 11.6286 8.09069C12.3134 7.42035 12.7055 6.50562 12.7185 5.54774ZM9.19036 0.0928832C10.0408 0.101572 10.8764 0.311386 11.6294 0.70526C12.3823 1.09913 13.0314 1.66594 13.5236 2.3596C14.0159 3.05325 14.3375 3.85415 14.4623 4.69717C14.5872 5.54018 14.5117 6.40151 14.242 7.21109C13.9723 8.02068 13.516 8.75566 12.9103 9.35626C12.3046 9.95686 11.5665 10.4061 10.7561 10.6675C9.94572 10.9289 9.08588 10.995 8.24651 10.8605C7.40715 10.726 6.61197 10.3947 5.92566 9.89341L1.52825 14.198C1.35615 14.3607 1.12743 14.4493 0.891333 14.4448C0.655238 14.4403 0.430665 14.343 0.265983 14.1739C0.1013 14.0048 0.00968421 13.7773 0.0108677 13.5405C0.0120511 13.3038 0.105939 13.0766 0.272309 12.908L4.66881 8.60439C4.10508 7.78794 3.77691 6.8309 3.72026 5.83815C3.66361 4.8454 3.88066 3.85524 4.34764 2.97619C4.81462 2.09713 5.51351 1.36309 6.36771 0.85451C7.22191 0.345928 8.19846 0.0824278 9.19036 0.0928832V0.0928832Z"
            fill="currentColor"
        />
    </svg>
);

export default SearchIcon;
